import * as commonUtils from '@Common/Helpers/CommonUtils';
import { BaseControl, IControlParameters } from './BaseControl';
import urlHelper from '@Common/Helpers/UrlHelper';

export interface IButtonParameters extends IControlParameters {
    html?: string;
    hoverCss?: any;
    mouseDownClass?: string;
    id?: any;
    minWidth?: any;
    text?: string;
    textColor?: string;
    icon?: any;
    backgroundColor?: string;
    tooltip?: any;
    fontSize?: string;
    borderRadius?: number;
    hover?: boolean;
    hoverClass?: string;
    toggle?: boolean;
    toggleBackground?: string;
    enabled?: boolean;
    lineHeight?: string;
    toggleClass?: string;
}

export class Button extends BaseControl<IButtonParameters> {
    private _onClick: ICallback<any> = $.noop;
    private _onChange = $.noop;
    private _value = false;

    constructor(param?: IButtonParameters) {
        super(param);
        this._param = $.extend(
            {
                css: null,
                className: '',
                width: 'auto',
                height: '30px',
                lineHeight: '0px',

                toggleClass: '',

                minWidth: null,
                text: '',
                textColor: '',
                icon: null,
                backgroundColor: null,
                tooltip: null,
                fontSize: null,
                borderRadius: 0,
                hover: true,
                hoverClass: 'button-hover',
                hoverCss: null,
                toggle: false,
                // toggleBackground: '#FF8A00',
                enabled: true
            },
            param
        );

        this._enabled = this._param.enabled;

        this._init();
        this._changeId();
        this.setState(this._param.enabled);
    }

    /* Private function */
    protected _init(): void {
        const buttonElement = document.createElement('button');
        buttonElement.classList.add('button');
        buttonElement.setAttribute('unselectable', 'on');
        if (this._param.tooltip) {
            buttonElement.setAttribute('title', this._param.tooltip);
        }
        const { lineHeight = '', minWidth = '', textColor: color = '', fontSize = '' } = this._param;
        this._root = $(buttonElement).css({ lineHeight, minWidth, color, fontSize });

        if (this._param.borderRadius) {
            this._root.css('border-radius', this._param.borderRadius + 'px');
        }

        this._root.on('click', e => {
            this._root.removeClass('button-hover');
            e.preventDefault();
            e.stopPropagation();

            if (this.enabled()) {
                if (this._param.toggle) {
                    this._value = !this._value;
                    this.value(this._value);
                }
                this._onClick(e);
            }
        });

        if (this._param.mouseDownClass) {
            this._root.on({
                mousedown: () => {
                    this._root.addClass(this._param.mouseDownClass);
                },
                mouseup: () => {
                    this._root.removeClass(this._param.mouseDownClass);
                }
            });
        }

        if (this._param.hover) {
            this._root.on({
                mouseenter: () => {
                    this._root.addClass(this._param.hoverClass);
                    if (this._param.hoverCss) {
                        this._root.css(this._param.hoverCss);
                    }
                },
                mouseleave: () => {
                    this._root.removeClass(this._param.hoverClass);
                    if (this._param.hoverCss) {
                        this._root.css(this._param.css);
                    }
                }
            });
        }

        if (this._param.icon) {
            if (this._param.text && this._param.text != '&nbsp;') {
                this._root.css({
                    'padding-left': '30px',
                    'background-position': '5px'
                });
            }
            const icon = this._param.icon;
            this._root.css({
                backgroundImage: `url(${icon.$value ? commonUtils.getImageSrc(icon) : `"${urlHelper.getImageUrl(icon)}"`})`
            });
        }

        this._param.backgroundColor
            ? this._root.css('background-color', this._param.backgroundColor)
            : (this._param.backgroundColor = this._root.css('background-color'));

        if (this._param.text) {
            this._root.text(this._param.text);
        } else if (this._param.html) {
            this._root.html(this._param.html);
        }

        this._applyDefaultParam();
    }

    private _changeId() {
        this._param.id ? this._root.attr('id', this._param.id) : this._root.removeAttr('id');
    }

    /* Public function */
    id(newId) {
        newId && (this._param.id = newId);
        return this._param.id;
    }

    enabled(en?: boolean) {
        if (en !== undefined) {
            this._enabled = en;
            this._root.toggleClass('disabled', !this._enabled);
            this._root.attr('disabled', !this._enabled as any);
        }

        return BaseControl.prototype.enabled.call(this, en);
    }

    // TODO: Remove setState, should be inly enabled
    setState(en) {
        this._enabled = en;
        this._root.toggleClass('disabled', !this._enabled);
        this._root.attr('disabled', !this._enabled as any);
        return this;
    }

    getState() {
        return this._enabled;
    }

    value(data?) {
        if (data === undefined) {
            return this._value;
        }

        this._value = data;

        if (this._param.toggleClass) {
            if (this._param.toggle && data === true) {
                this._root.removeClass(this._param.className);
                this._root.addClass(this._param.toggleClass);
            } else {
                this._root.removeClass(this._param.toggleClass);
                this._root.addClass(this._param.className);
            }
        } else {
            this._root.toggleClass('button-toggled', this._value);
        }
        this._onChange();
    }

    setText(text) {
        if (text === undefined) {
            return this._root.text();
        }

        this._root.text(text);

        return text;
    }

    getText() {
        return this._root.text();
    }

    setImage(image) {
        this._root.css('background-image', urlHelper.getCssImageUrl(image));
    }

    setTooltip(tooltip) {
        this._root.attr('title', tooltip);
    }

    /* Public events */
    onClick(fn) {
        this._onClick = fn;
    }

    /* Public events */
    onChange(fn) {
        this._onChange = fn;
    }
}
